// components
import { Container, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import Page from 'src/components/molecules/page';
import { AccountForm } from 'src/components/organisms/account/form';

export const AccountCreatePage: FC = () => {
  /* 定数宣言 */
  const title = 'アカウント新規';

  return (
    <Page title={title}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Stack>
        <AccountForm />
      </Container>
    </Page>
  );
};
